import React from 'react';
import Toggler from '../Toggler';
import { translate } from '../../Services/translation';
import { useTypedDispatch } from '../../Hooks/useTypedDispatch';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { setShowRoomImage } from '../../Actions/ProductListing.action';
import { useCookies } from 'react-cookie';

const PatternImageToggler = () => {
  const [cookies] = useCookies([`pattern-image-cookie`]);
  const { showRoomImage } = useTypedSelector(
    (state) => state.productListing
  );

  const [_, setCookie] = useCookies([`pattern-image-cookie`]);
  const dispatch = useTypedDispatch();

  const onClick = () => {
    setCookie('pattern-image-cookie', !showRoomImage);
    dispatch(setShowRoomImage(!showRoomImage));
  };

  return (
    <Toggler
      initialState={!showRoomImage}
      label={translate('category.show-patterns')}
      onClick={onClick}
    />
  );
};

export default PatternImageToggler;
